import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for RecommendedPlansStore, for use in the registry */ export const RecommendedPlansStoreActionTypes = [
    ActionType.SetRecommendedPlansAction,
    ActionType.SetRecommendedPlansFailedAction,
    ActionType.RemovePlanFromRecommendedListAction
];
